export default __webpack_public_path__ + "static/media/practice-icon.f848b5a3.jpg";